// Global storefront behavior: mobile menu, search, accordions, product gallery, variants, quantity.
document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    menu?.classList.toggle('is-open', !expanded);
  }

  const searchToggle = event.target.closest('[data-search-toggle]');
  if (searchToggle) {
    const search = document.querySelector('[data-search-form]');
    const expanded = searchToggle.getAttribute('aria-expanded') === 'true';
    searchToggle.setAttribute('aria-expanded', String(!expanded));
    search?.classList.toggle('is-open', !expanded);
    search?.querySelector('input')?.focus();
  }

  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const main = document.querySelector('[data-gallery-main]');
    const src = thumb.getAttribute('data-full-src');
    const alt = thumb.getAttribute('data-alt') || '';
    if (main && src) main.innerHTML = `<img src="${src}" alt="${alt}">`;
  }

  const plus = event.target.closest('[data-quantity-plus]');
  const minus = event.target.closest('[data-quantity-minus]');
  if (plus || minus) {
    const wrap = event.target.closest('[data-quantity]');
    const input = wrap?.querySelector('input');
    if (!input) return;
    const value = Math.max(1, parseInt(input.value || '1', 10) + (plus ? 1 : -1));
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-option-position]');
  if (!select) return;

  const form = select.closest('[data-product-form]');
  const variantsScript = form?.querySelector('[data-product-variants]');
  const idInput = form?.querySelector('[data-variant-id]');
  if (!form || !variantsScript || !idInput) return;

  const selected = Array.from(form.querySelectorAll('[data-option-position]')).map((el) => el.value);
  const variants = JSON.parse(variantsScript.textContent);
  const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
  const submit = form.querySelector('.product-form__submit');

  if (variant) {
    idInput.value = variant.id;
    if (submit) {
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? window.themeAddToCartText || 'Add to cart' : window.themeSoldOutText || 'Sold out';
    }
  }
});

const marketingPopup = document.querySelector('[data-marketing-popup]');
if (marketingPopup) {
  const campaignKey = marketingPopup.dataset.campaignKey || 'default';
  const storageKey = `rellumo-email-offer:${campaignKey}`;
  const delay = Math.max(5, Number(marketingPopup.dataset.delaySeconds || 15)) * 1000;
  const frequency = Math.max(1, Number(marketingPopup.dataset.frequencyDays || 30)) * 86400000;
  const success = marketingPopup.querySelector('[data-marketing-success]');

  const readState = () => {
    try { return JSON.parse(localStorage.getItem(storageKey) || '{}'); } catch (_) { return {}; }
  };
  const writeState = (state) => {
    try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch (_) { /* Storage can be unavailable in private modes. */ }
  };
  const showPopup = () => {
    marketingPopup.hidden = false;
    requestAnimationFrame(() => marketingPopup.classList.add('is-visible'));
  };
  const closePopup = () => {
    marketingPopup.classList.remove('is-visible');
    writeState({ ...readState(), dismissedAt: Date.now() });
    window.setTimeout(() => { marketingPopup.hidden = true; }, 220);
  };

  marketingPopup.querySelector('[data-marketing-popup-close]')?.addEventListener('click', closePopup);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !marketingPopup.hidden) closePopup();
  });

  if (success) {
    writeState({ subscribedAt: Date.now() });
    showPopup();
  } else if (window.Shopify?.designMode) {
    showPopup();
  } else {
    const state = readState();
    const dismissedRecently = state.dismissedAt && Date.now() - state.dismissedAt < frequency;
    const alreadySubscribed = Boolean(state.subscribedAt);
    if (!dismissedRecently && !alreadySubscribed) window.setTimeout(showPopup, delay);
  }
}
